function DeleteFragmentModalController(stateService) {
  const ctrl = this;

  ctrl.$onInit = async() => {
    ctrl.fragment = ctrl.resolve.fragment;
    ctrl.workspaceId = ctrl.resolve.workspaceId;
    ctrl.fragment = await stateService.getFragment(ctrl.workspaceId, ctrl.fragment.id);
    checkIfInUse(ctrl.fragment);
  };


  const checkIfInUse = async(fragment) => {
    const fullFragmentInformation = await stateService.getFragment(ctrl.workspaceId, fragment.id);
    if (fullFragmentInformation.conditions.length > 0 || fullFragmentInformation.triggers.length > 0 || fullFragmentInformation.streams.length > 0) {
      ctrl.fragment.deletable = false
    } else {
      ctrl.fragment.deletable = true
    }
  };

  ctrl.submit = () => {
    ctrl.close({ $value: ctrl.fragment.id });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('pis-tool.module')
  .controller('DeleteFragmentModalController', DeleteFragmentModalController);
